import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { LoaderService } from 'src/app/loader.service';
import { RfidServiceService } from 'src/app/_service/rfid-service.service';

@Component({
  selector: 'telio-rfid-details',
  templateUrl: './rfid-details.component.html',
  styleUrls: ['./rfid-details.component.scss']
})
export class RfidDetailsComponent implements OnInit,OnDestroy {
  rfidTag;
  rfidDetails;
  rfidSubscription = new Subscription()

  constructor(private route: ActivatedRoute,
    private rfidService: RfidServiceService,
    private router: Router,
    public loaderService: LoaderService) { }

  ngOnInit(): void {
    this.rfidSubscription.add(this.route.queryParams.subscribe((params) => {
      this.rfidTag = params.rfidId;
    }));

    this.rfidSubscription.add(this.rfidService.getRfidDetailsById(this.rfidTag).subscribe(resp => {
      Object.keys(resp).map(x => {
        if (resp[x] !== false) {
          (!resp[x] || resp[x] == '') ? resp[x] = 'NA' : null;
        }
      })
      this.rfidDetails = resp;
    }))
  }

  ngOnDestroy() {
    this.rfidSubscription && this.rfidSubscription.unsubscribe();
  }

  topback() {
    this.router.navigate(['/dashboard/rfid', { routeID: this.route.snapshot.paramMap.get('routeID') }]);
  }
}
